import html2canvas from 'html2canvas'
import { useMap } from 'ms-map-gl'
import { useEffect, useState } from 'react'
import {
  useDimension,
  useInfographicLegend,
  useInfographicTitle
} from '~map-preview/states/infographic'

export const useCaptureMapInfographic = () => {
  const { width, height } = useDimension()
  const { default: map } = useMap()
  const isInfographicTitle = useInfographicTitle()
  const isInfographicLegend = useInfographicLegend()

  const [url, setUrl] = useState<string>()

  useEffect(() => {
    if (!map) return

    const renderMapInfographic = async () => {
      const canvas = cloneToCenteredSquareCanvas(map.getCanvas(), width, height)
      await addTitleAndLegendToCanvas(canvas, 'MapTitle', 'MapLegend')
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error('Could not convert canvas to blob')
          return
        }
        setUrl(URL.createObjectURL(blob))
      }, 'image/png')
    }

    map.on('idle', renderMapInfographic)

    map.redraw()

    return () => {
      map.off('idle', renderMapInfographic)
    }
  }, [map, width, height, isInfographicTitle, isInfographicLegend])

  const cloneToCenteredSquareCanvas = (
    originalCanvas: HTMLCanvasElement,
    width: number,
    height: number
  ) => {
    const clonedCanvas = document.createElement('canvas')
    clonedCanvas.width = width
    clonedCanvas.height = height

    const context = clonedCanvas.getContext('2d')
    if (!context) {
      throw new Error('Could not get 2d context from canvas')
    }

    context.drawImage(originalCanvas, 0, 0, width, height, 0, 0, width, height)

    return clonedCanvas
  }

  const addTitleAndLegendToCanvas = async (
    canvas: HTMLCanvasElement,
    titleElementId: string,
    legendElementId: string
  ) => {
    const context = canvas.getContext('2d')
    if (!context) {
      throw new Error('Could not get 2d context from canvas')
    }

    // Capture title element
    const titleElement = document.getElementById(titleElementId)
    if (titleElement) titleElement.style.boxShadow = 'none'

    if (titleElement) {
      const titleCanvas = await html2canvas(titleElement, {
        backgroundColor: null
      })
      context.drawImage(titleCanvas, (canvas.width - titleCanvas.width) / 2, 10)
    }

    // Capture legend element
    const legendElement = document.getElementById(legendElementId)

    if (legendElement) {
      const legendCanvas = await html2canvas(legendElement, {
        backgroundColor: null
      })
      context.drawImage(
        legendCanvas,
        (canvas.width - legendCanvas.width) / 2,
        canvas.height - legendCanvas.height - 10
      )
    }
  }

  return url
}
